var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-ww"},[_c('login',{staticClass:"login-container",attrs:{"auth-url":"https://api.huishoubao.com/api/user/oauthLogin","logo":_vm.logo,"auth-prams":_vm.authPrams}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }